export class AuthResponse {
    'accessToken';
    'expiresIn';
    'idToken';
    'refreshToken';
    'tokenType';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessToken",
            "baseName": "accessToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresIn",
            "baseName": "expiresIn",
            "type": "number",
            "format": ""
        },
        {
            "name": "idToken",
            "baseName": "idToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "refreshToken",
            "baseName": "refreshToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "tokenType",
            "baseName": "tokenType",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AuthResponse.attributeTypeMap;
    }
    constructor() {
    }
}
